export const CaseImage = ({ campaign: c }) => {
  return (
    <section className="hairline-b border-b">
      <div className="max-w-[1680px] mx-auto px-5 md:px-10 py-12 md:py-16">
        <div
          data-testid="case-hero-image"
          className="relative w-full hairline border bg-[var(--ink)] overflow-hidden"
        >
          <img
            src={c.image}
            alt={c.title}
            className="w-full h-auto object-cover"
            loading="eager"
          />
        </div>
        <p className="mt-4 text-[10.5px] tracking-[0.22em] uppercase opacity-50">
          Fig. 01 — {c.title}, original case film
        </p>
      </div>
    </section>
  );
};
